export const InvoiceTypes = [
    { label: "Invoiced", value: "invoiced" },
    { label: "Void", value: "void" },
]